module.exports = __webpack_public_path__ + "static/media/fundraiser-step-2.7d972420.svg";